import { ActivatedRoute } from '@angular/router';

/**
 * Hydrates a service with route-resolved data, using Angular signals.
 */
export function hydrateFromRoute<T = unknown>(
  route: ActivatedRoute,
  key: string,
  fn: (data: T) => void
) {
  const snapshotData = route.snapshot.data[key];
  if (snapshotData) {
    fn(snapshotData as T);
  }

  route.data.subscribe(data => {
    const resolved = data[key];
    if (resolved) {
      fn(resolved as T);
    }
  });
}
